import { SvgIcon, SvgIconProps } from "@sol/uikit/core/icons/SvgIcon";

export const AddSquare01 = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24">
            <g id="add-square-01">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.375 4C5.06332 4 4 5.06332 4 6.37498V17.625C4 18.9367 5.06332 20 6.375 20H17.625C18.9367 20 20 18.9367 20 17.625L20 6.37498C20 5.06332 18.9367 4 17.625 4H6.375ZM2 6.37498C2 3.95874 3.95876 2 6.375 2H17.625C20.0412 2 22 3.95874 22 6.37498L22 17.625C22 20.0413 20.0412 22 17.625 22H6.375C3.95876 22 2 20.0413 2 17.625V6.37498ZM12.0004 7.62447C12.5527 7.62447 13.0004 8.07218 13.0004 8.62447L13.0004 10.9995H15.3754C15.9277 10.9995 16.3754 11.4472 16.3754 11.9995C16.3754 12.5517 15.9277 12.9995 15.3754 12.9995H13.0004V15.3744C13.0004 15.9267 12.5527 16.3744 12.0004 16.3744C11.4481 16.3744 11.0004 15.9267 11.0004 15.3744V12.9995H8.62537C8.07308 12.9995 7.62537 12.5517 7.62537 11.9995C7.62537 11.4472 8.07308 10.9995 8.62537 10.9995H11.0004L11.0004 8.62447C11.0004 8.07219 11.4481 7.62447 12.0004 7.62447Z"
                    className="fill-current"
                />
            </g>
        </SvgIcon>
    );
};
